/**
 * Consulta do log de requisicoes.
 *
 * A tela existe para duas perguntas concretas, e os filtros sao desenhados
 * para elas: "o que deu errado?" e "o que esta lento?". Navegar o log inteiro
 * em ordem cronologica nao e caso de uso de ninguem -- sao centenas de
 * milhares de linhas.
 *
 * **A permissao desta tela e a da API, nao uma de tela.** O codigo
 * `accounts.logs` mora na ferramenta `api/log` do servico `hliberty.log` --
 * quem entrega os dados --, e nao numa ferramenta de tela do
 * `hliberty.accounts`. No auth, `codes` e a lista que o `isAuthorized` confere
 * saem da mesma linha da consulta, entao `accounts.logs:ver` existe para a
 * pessoa se e somente se `GET api/log` e permitido a ela. Tela visivel e API
 * permitida passam a ser a mesma pergunta.
 *
 * Com o codigo numa tela do `hliberty.accounts` as duas se separavam: toda
 * empresa com o accounts e sem o `hliberty.log` via a tela (grupo admin ganha
 * tudo dos servicos contratados) e tomava 401 ao abrir -- osirnet, 05/11/2026.
 *
 * `servico` e o que faz o menu e o guard ESCONDEREM a tela quando o codigo
 * nao esta no catalogo da empresa, em vez de liberar como "ainda nao
 * cadastrado". Ver `pode()` em services/permissao.js.
 */
const servico = 'hliberty.log';

export const nav = {
    section: 'Resources',
    title: 'Logs',
    icon: 'receipt_long',
    route: '/logs',
    accordion: false,
    permissao: 'accounts.logs:ver',
    servico,
};

export default [
    {
        path: '/logs',
        name: '/logs',
        component: () => import('./pages/LogsListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.logs:ver', servico },
    },
];
